const NO_SEAT_CHARACTERISTIC = 'NO_SEAT';

module.exports = {
    generatePreferredSeatsThresholds: function(descriptors) {
        var segments = Odigeo._.filter(descriptors.attributes, Odigeo._.isObject);
        return Odigeo._.reduce(segments, function(segmentsPriceIntervals, segment) {
            var segmentIntervals = this.getSegmentPreferredSeatsThresholds(segment);
            return Odigeo._.assign(segmentIntervals, segmentsPriceIntervals);
        }, {}, this);
    },
    getSegmentPreferredSeatsThresholds: function(segment) {
        return Odigeo._.reduce(segment.seatMap, function(sectionsPriceIntervals, section) {
            var sectionInterval = this.getSectionSeatsPriceIntervals(section.cabin);
            var sectionThreshold = this.calculatePreferredSeatThreshold(sectionInterval);
            var sectionObject = {};
            sectionObject[section.section] = sectionThreshold;

            return Odigeo._.assign(sectionObject, sectionsPriceIntervals);
        }, {}, this);
    },
    getSectionSeatsPriceIntervals: function(section) {
        var intervals = Odigeo._.map(Odigeo._.uniq(Odigeo._.flatten(Odigeo._.map(section, function(cabin) {
            return Odigeo._.filter(cabin.seats.seat, function(seat) {
                return Odigeo._.includes(seat.seatCharacteristics.characteristic, 'CHARGEABLE_SEAT') &&
                    !Odigeo._.includes(seat.seatCharacteristics.characteristic, 'EXTRA_LEG') &&
                    seat.totalPrice > 0;
            });
        })), 'totalPrice'), 'totalPrice');
        return intervals;
    },
    calculatePreferredSeatThreshold: function(intervals) {
        return Odigeo._.isArray(intervals) && intervals.length >= 3 ?
            Odigeo._.max(intervals) - (Odigeo._.max(intervals) - Odigeo._.min(intervals)) * 0.1 : 0;
    },
    getCheapestSeat(seats) {
        return seats.reduce((currentCheaperSeat, seat) => {
            const validSeatCharacteristic = seat.type
                && seat.type !== NO_SEAT_CHARACTERISTIC
                && seat.seatType !== NO_SEAT_CHARACTERISTIC;
            const validPrice = Odigeo._.isNumber(seat.totalPrice) && seat.totalPrice >= 0;
            const hasLowerPrice = Odigeo._.isUndefined(currentCheaperSeat) || currentCheaperSeat.totalPrice > seat.totalPrice;
            return validSeatCharacteristic && validPrice && hasLowerPrice ? seat : currentCheaperSeat;
        }, undefined);
    },
    getCheapestPrimeSeat(seats) {
        return seats.reduce((currentCheaperSeat, seat) => {
            const validSeatCharacteristic = seat.type && seat.type !== NO_SEAT_CHARACTERISTIC && seat.seatType !== NO_SEAT_CHARACTERISTIC;
            const validPrimePrice = Odigeo._.isNumber(seat.totalPrimePrice) && seat.totalPrimePrice >= 0;
            const hasLowerPrimePrice = Odigeo._.isUndefined(currentCheaperSeat) || currentCheaperSeat.totalPrimePrice > seat.totalPrimePrice;
            return validSeatCharacteristic && validPrimePrice && hasLowerPrimePrice ? seat : currentCheaperSeat;
        }, undefined);
    },
    getPrimeDiscountsInfo(seats) {
        let highestPrimeDiscountPercentage = 0;
        let minSectionPrimePrices;
        const mostDiscountedPrimeSeat = seats.reduce((currentMostDiscountedSeat, seat) => {
            const validSeatCharacteristic = seat.type && seat.type !== NO_SEAT_CHARACTERISTIC && seat.seatType !== NO_SEAT_CHARACTERISTIC;
            const validPrice = Odigeo._.isNumber(seat.totalPrice) && seat.totalPrice >= 0;
            const validPrimePrice = Odigeo._.isNumber(seat.totalPrimePrice) && seat.totalPrimePrice >= 0;
            const validSeat = validSeatCharacteristic && validPrice && validPrimePrice;
            const discountAmount = validSeat ? seat.totalPrice - seat.totalPrimePrice : 0;
            const discountPercentage = validSeat ? Math.ceil((discountAmount * 100) / seat.totalPrice) : 0;

            const currentDiscountAmount = Odigeo._.isUndefined(currentMostDiscountedSeat)
                ? 0
                : currentMostDiscountedSeat.totalPrice - currentMostDiscountedSeat.totalPrimePrice;
            const hasHigherDiscountPrice = Odigeo._.isUndefined(currentMostDiscountedSeat) || discountAmount > currentDiscountAmount;
            highestPrimeDiscountPercentage =
                validSeat && discountPercentage > highestPrimeDiscountPercentage ? discountPercentage : highestPrimeDiscountPercentage;
            minSectionPrimePrices = validSeat
                && (Odigeo._.isUndefined(minSectionPrimePrices) || seat.totalPrimePrice < minSectionPrimePrices.totalPrimePrice) ?
                {
                    totalPrice: seat.totalPrice,
                    totalPrimePrice: seat.totalPrimePrice,
                }
                : minSectionPrimePrices;
            return validSeat && hasHigherDiscountPrice ? seat : currentMostDiscountedSeat;
        }, undefined);

        return {
            mostDiscountedPrimeSeat,
            highestPrimeDiscountPercentage,
            minSectionPrimePrices,
        };
    },
    getMaxTotalPrimeDiscount(seats, numTravellers) {
        const amountAllSections = Math.floor(seats.reduce((acc, cur) => acc + (cur.totalPrice - cur.totalPrimePrice), 0));
        const totalDiscount = numTravellers * amountAllSections;

        return totalDiscount > 0 ? totalDiscount : 0;
    },
};
